import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {transition, visuallyHidden} from 'helpers/css';
import outline from 'helpers/outline';

export interface RadioProps extends
  React.InputHTMLAttributes<HTMLInputElement> {
  label?: string | React.ReactNode;
}

export const Container = styled.label`
  display: inline-grid;
  cursor: pointer;
`;

const Content = styled.div`
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
  grid-auto-flow: column;
  display: inline-grid;
`;

export const Round = styled.div`
  box-sizing: border-box;
  border: 1px solid ${({theme}) => (
    transparentize(.85, theme.variables.color)
  )};
  border-radius: 50%;
  height: 16px;
  width: 16px;
  
  ${transition()};
`;

export const HiddenInput = styled.input`
  ${visuallyHidden};
  
  &:checked + div {
    ${Round} {
      border: ${({theme}) => `4px solid ${theme.colors.primary}`};
    }
  }
  
  &:focus-visible + div {
    ${outline(6, 2)};
  }
`;

const Label = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  user-select: none;
`;

/**
 * The component render radio
 * @param {RadioProps} props
 * @return {JSX.Element}
 */
export default function Radio(props: RadioProps): React.ReactElement {
  const {label, ...otherProps} = props;

  return (
    <Container>
      <HiddenInput
        {...otherProps}
        type="radio"
      />
      <Content>
        <Round />
        {label && (
          <Label>
            {label}
          </Label>
        )}
      </Content>
    </Container>
  );
}
